import React from "react";
import { Box, Typography } from "@mui/material";
import { Compass } from "react-feather";
import useWindowSize from "utils/useWindowSize";
import { textAlign } from "@mui/system";

const tabs = [
  {
    title: "Expert knowledge",
    content: (
      <p>
        Dedicated professional from beginning to end <br />
      </p>
    ),
    content1: <p>Refined itineraries tested by travel experts</p>,
    content2: <p>Plan efficiently to save your resources</p>,
    icon:'url(/pages/expert.png)'
  },
  {
    title: "Customised itinerary",
    content: <p>Flexible schedule according to your pace</p>,
    content1: <p>Exclusive and engaging activities</p>,
    content2: <p>Comprehensive selections of places to stay, eat and ride</p>,
    icon:'url(/pages/itinerary.png)'
  },
  
  {
    title: "Safety and reliability",
    content: <p>Partnership with professional logistics suppliers</p>,
    content1: <p>Presentation of essential guidelines </p>,
    content2: <p>Constant risk assessment</p>,
    icon:'url(/pages/shield.png)'
  },
  {
    title: '”Always on”',
    title1: "customer  care",
    content: <p>Instant response</p>,
    content1: <p>24/7 availability</p>,
    content2: <p>Real-time problem solving</p>,
    icon:'url(/pages/solidarity.png)'
  },
];

// 1 = expert
const WhyTravel = () => {
  const { sizes } = useWindowSize();

  return (
    <Box className="flex justify-center flex-wrap">
      {tabs.map((item, index) => (
        <Box
          key={index}
          className="bg-[#fff] w-[250px] h-[340px] p-[20px] m-[20px]"
        >
          <Box className="flex justify-center">
            <Box className="mt-[-50px] flex justify-center bg-[#243d7f] h-[60px] w-[60px] rounded-full items-center">
              <Box
                className="h-[32px] w-[32px]  "
                style={{
                  backgroundPosition: "center",
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "contain",
                  backgroundImage: item.icon,
                }}
              ></Box>
            </Box>
          </Box>

          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              fontFamily: '"Merriweather", serif',
              // fontStyle: "italic",
              fontWeight: 400,
              fontSize: 22,
              textAlign: "center",
              marginTop: 4,
            }}
          >
            {item.title}
            <br />
            {item.title1}
          </Box>
          <Box
            style={{
              textAlign: "center",
              marginTop: 15,
              fontSize: 13,
              borderBottom: "1px solid #f1f1f1",
              paddingBottom: 8,
            }}
          >
            {item.content}
          </Box>
          <Box
            style={{
              marginTop: 15,
              fontSize: 13,
              textAlign: "center",
              borderBottom: "1px solid #f1f1f1",
              paddingBottom: 8,
            }}
          >
            {item.content1}
          </Box>
          <Box
            style={{
              marginTop: 15,
              fontSize: 13,
              textAlign: "center",

              borderBottom: "1px solid #f1f1f1",
              paddingBottom: 8,
            }}
          >
            {item.content2}
          </Box>
        </Box>
      ))}
    </Box>
  );
};

export default WhyTravel;
